import { isBusinessApp } from './platform';

// Route that tells a CLIENT account the business app isn't for them and points
// them at the consumer Petzy app. Must live OUTSIDE SalonLayout and the
// '/' → dashboard redirect so a rejected client can actually land on it.
export const CLIENT_REJECT_PATH = '/client-app';

// Where an authenticated role lands after login IN THE BUSINESS BUILD.
// - SALON_OWNER / SPECIALIST → the dashboard
// - ADMIN → the admin panel
// - CLIENT / anything else → the reject screen (which self-logs-out on mount)
// Returns null when NOT in business mode, so every caller falls through to its
// existing web / client-native redirect logic completely untouched.
export function businessPostAuthPath(role) {
  if (!isBusinessApp) return null;
  // Role still hydrating (session loading / no user yet) — return null so the
  // caller waits, instead of falling through to the CLIENT reject screen
  // (which self-logs-out) before we even know the real role.
  if (!role) return null;
  if (role === 'SALON_OWNER' || role === 'SPECIALIST') return '/salon/dashboard';
  if (role === 'ADMIN') return '/admin';
  return CLIENT_REJECT_PATH;
}

// True when an authenticated role may use the business dashboard at all.
export function isBusinessRole(role) {
  return role === 'SALON_OWNER' || role === 'SPECIALIST' || role === 'ADMIN';
}
